module.exports = __webpack_public_path__ + "static/media/press-hunt-logo-clear.95ef4c45.svg";